export default {
  'system.title': 'システム要件',
  'system.required':
    '本サービスは以下の環境で動作します。<br />' +
    'iOS / iPadOS 14.1 以上のオペレーティングシステム<br />' +
    'Android 11 以上の純正オペレーティングシステム<br />' +
    '*カスタマイズされたOSを搭載したデバイスでは動作しない可能性があります。',
} as Record<string, string>;
